export const primaryColour = '#44689a'
export const secondaryColour = '#87bafc'
export const tertiaryColour = '#87bafc'

export const defaultDarkTextColour = '#2d2d2d'
